exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-image-dialog {\n  display: block;\n  width: 100%;\n}\nfi-image-dialog .fi-dialog-content img {\n  width: 100%;\n  height: auto;\n}", ""]);

// exports
